<template>
  <div class="organization-details-view">
    <div class="organization-details-view__header">
      <h3>Detalle de la Organización</h3>
    </div>
    <div v-if="!fetchingOrganization" v-loading="fetchingOrganization" class="organization-details-view__content">
      <div class="organization-details-view__organization-info">
        <div class="organization-details-view__organization-item">
          <h3>{{ organization.name }}</h3>
          <div>Código: {{ organization.code }}</div>
          <div>Rut: {{ organization.rut }}</div>
          <div>Origen: {{ organizationSource }}</div>
          <div>Dirección: {{ organization.address }}</div>
        </div>
      </div>
      <div class="organization-details-view__organization_users">
        <div class="organization-details-view__organization_users-header">
          <h5>Usuarios de esta organización</h5>
          <button class="btn btn-success" @click.prevent="handleClickAddUser" v-if="isAdmin">
            <i class="fas fa-plus-circle" /> Nuevo Usuario
          </button>
        </div>
        <user-table
          ref="userTable"
          :users="users"
          :hide-organization="true"
          :default-organization="organization"
          :hide-user-role="false"
          :pagination="pagination"
          @delete-user="handleDeleteUser"
          @save-user="handleUserSaved"
          @page-change="handlePageChange">
          <template v-slot:additional-actions="{ user }">
            <el-tooltip
              class="item"
              effect="dark"
              :disabled="user.organizations.length !== 1 && isAdmin"
              content="No es posible quitar al usuario de esta organización, debe eliminarlo."
              placement="top-start">
              <button :disabled="isQuitar(user)" class="btn btn-sm btn-warning" @click.prevent="handleClickRemoveUser(user)">
                Quitar
              </button>
            </el-tooltip>
          </template>
        </user-table>
      </div>
    </div>
  </div>
</template>

<script>
import UserTable from '@/components/user/UserTable';

const OrganizationSources = {
  'medical_center': 'Centro Médico',
  'midas': 'Midas'
};

export default {
  name: 'OrganizationDetailsView',
  components: { UserTable },
  data() {
    const type = this.$route.params.type === 'dispenser_admin' ? 'dispenser' : this.$route.params.type;
    return {
      type: type,
      uuid: this.$route.params.organization_uuid,
      organization: {},
      users: [],
      fetchingOrganization: true,
      fetchingOrganizationUsers: true,
      pagination: {
        total: 0,
        page: 1,
        perPage: 20
      }
    };
  },
  computed: {
    organizationSource() {
      return OrganizationSources.hasOwnProperty(this.organization.source)
        ? OrganizationSources[this.organization.source]
        : this.organization.source;
    },
    isAdmin(){
      return this.$store.getters.hasRole('admin');
    }
  },
  created() {
    this.fetchOrganization();
    this.fetchOrganizationUsers();
  },
  methods: {
    fetchOrganization() {
      this.fetchingOrganization = true;
      this.$store.dispatch('fetchOrganization', { uuid: this.uuid })
        .then(organization => {
          this.organization = organization;
        })
        .finally(() => {
          this.fetchingOrganization = false;
        });
    },
    handlePageChange(page) {
      this.fetchOrganizationUsers({
        page
      });
    },
    fetchOrganizationUsers(options = {}) {
      options = {
        uuid: this.uuid,
        ...this.pagination,
        ...options
      };
      this.fetchingOrganizationUsers = true;
      this.$store.dispatch('fetchOrganizationUsers', options)
        .then(response => {
          this.users = response.data.map(u => {
            u.organization = this.organization;
            return u;
          });
          this.pagination = {
            total: parseInt(response.total),
            perPage: parseInt(response.perPage),
            page: parseInt(response.page)
          };
        })
        .finally(() => {
          this.fetchingOrganizationUsers = false;
        });
    },
    handleClickAddUser() {
      this.$refs.userTable.handleClickAddUser();
    },
    handleUserSaved() {
      this.fetchOrganizationUsers();
    },
    handleClickRemoveUser(user) {
      console.log('el usuario es:', user);
      this.$confirm(`Está seguro que desea quitar el usuario ${user.claveunica_id} de la organización`, 'Confirmar quitar usuario', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        if (user.organizations.length === 1){
          this.deleteUser(user);
          return;
        }
        this.removeOrganizationUser(user);
      }).catch(() => {});
    },
    handleDeleteUser(user) {
      this.$confirm(`Está seguro que desea eliminar el usuario ${user.claveunica_id}`, 'Confirmar eliminación de usuario', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.deleteUser(user);
      }).catch(() => {});
    },
    deleteUser(user) {
      this.$store.dispatch('deleteUser', user)
        .then(response => {
          this.$message({
            type: 'success',
            message: 'Usuario eliminado'
          });
          this.fetchOrganizationUsers();
        });
    },
    removeOrganizationUser(user) {
      this.$store.dispatch('removeOrganizationUser', {
        user,
        organization: this.organization
      })
        .then(response => {
          this.$message({
            type: 'success',
            message: 'El usuario se ha quitado de la organización'
          });
          this.fetchOrganizationUsers();
        });
    },
    isQuitar(user){
      return this.$store.getters.hasRole('admin') && user.organizations.length === 1;
    }
  }
};
</script>

<style lang="scss">
  .organization-details-view {
    padding: $--spacing-6;

    &__header {
      display: flex;
      justify-content: space-between;
      padding-bottom: $--spacing-6;
      margin-bottom: $--spacing-6;
      border-bottom: 1px solid $--color-light-gray;
    }

    &__organization-info {
      background-color: $--color-white;
      border: 1px solid $--color-light-gray;
      padding: $--spacing-4;
      margin-bottom: $--spacing-6;

      h3 {
        font-size: $--font-size-md;
      }

      h4 {
        font-size: $--font-size-base;
      }
    }

    &__user-item:not(:last-child) {
      border-bottom: 1px solid #E6E6E6;
      padding-bottom: $--spacing-2;
      margin-bottom: $--spacing-2;
    }

    &__organization_users {
      &-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
      }

      .users-table {
        margin-top: $--spacing-4;
        background-color: $--color-white;
      }
    }
  }
</style>
